import { baseApi } from '@shared/api/baseApi';

export interface MaintenanceDto {
  enabled: boolean;
  message: string | null;
  /** Relative URL to the notice image, or null when none is set. */
  imageUrl: string | null;
}

export const maintenanceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMaintenance: builder.query<MaintenanceDto, void>({
      query: () => '/maintenance',
      providesTags: ['Maintenance'],
    }),
  }),
});

export const { useGetMaintenanceQuery } = maintenanceApi;
